module.exports = "<p>clinicdx works!</p>\n"